import { DataField } from '@vendasta/smsv2';

export const NORTH_AMERICA_COUNTRIES = ['US', 'CA'];

// A2P registration feature launch date
export const A2P_START_DATE = new Date(2023, 1, 1);

export const RegistrationStage = {
  NotSubmitted: 0,
  ReviewingInfo: 1,
  RegistrationComplete: 2,
  DataError: 3,
  CampaignError: 4,
} as const;
export type RegistrationStage = (typeof RegistrationStage)[keyof typeof RegistrationStage];

export const EIN_REGEX = /^\d{2}-\d{7}$/;
export const ZIP_CODE_REGEX = /^\d{5}(?:-\d{4})?$/;
export const URL_REGEX = /^https?:\/\/.+/i;
export const HTTPS_URL_REGEX = /^https:\/\/.+/i;
export const IDENTIFIER_TYPE_EIN = 'EIN';

export const DATA_FIELD_TO_FORM_FIELD = new Map<DataField, string>([
  [DataField.DATA_FIELD_LEGAL_BUSINESS_NAME, 'businessName'],
  [DataField.DATA_FIELD_BUSINESS_CATEGORY, 'businessCategory'],
  [DataField.DATA_FIELD_BUSINESS_TYPE, 'businessType'],
  [DataField.DATA_FIELD_REGION_OF_OPERATION, 'regionOfOperation'],
  [DataField.DATA_FIELD_BUSINESS_REGISTRATION_NUMBER, 'businessRegistrationNumber'],
  [DataField.DATA_FIELD_STREET_ADDRESS, 'address'],
  [DataField.DATA_FIELD_STREET_ADDRESS_SECONDARY, 'additionalAddressLine'],
  [DataField.DATA_FIELD_CITY, 'city'],
  [DataField.DATA_FIELD_STATE, 'state'],
  [DataField.DATA_FIELD_POSTAL_CODE, 'zipCode'],
  [DataField.DATA_FIELD_WEBSITE_URL, 'website'],
  [DataField.DATA_FIELD_COUNTRY, 'country'],
  [DataField.DATA_FIELD_FIRST_NAME, 'firstName'],
  [DataField.DATA_FIELD_LAST_NAME, 'lastName'],
  [DataField.DATA_FIELD_JOB_POSITION, 'jobPosition'],
  [DataField.DATA_FIELD_BUSINESS_TITLE, 'businessTitle'],
  [DataField.DATA_FIELD_EMAIL, 'email'],
  [DataField.DATA_FIELD_PHONE_NUMBER, 'phoneNumber'],
]);
